/* global document, Drupal, jQuery */
(($) => {
  Drupal.behaviors.slideshow = {
    attach: () => {
      $(document).ready(() => {
        $('body').once('summit-slideshow').each(() => {
          document.querySelectorAll('.paragraph--type-slideshow').forEach((paragraph) => {

            // Init slick
            const slides = paragraph.querySelector('.field--name-field-images');
            $(slides).slick({
              slidesToShow: 1,
              mobileFirst: false,
              centerMode: true,
              draggable: true,
              infinite: true,
              speed: 800,
              swipeToSlide: true,
              variableWidth: true,
            });
          });
        });
      });
    },
  };
})(jQuery);
